import Task from '@/components/nodes/task/task';
import idConfigSettings from '@/components/inspectors/idConfigSettings';
import userTask from '!!url-loader!@/assets/user-task.svg';
import rules from '@/mixins/ilios_functions.js'

window.ProcessMaker.EventBus.$on('modeler-init', ({ registerNode }) => {
  /* Add a custom node example */

  const implementation = 'processmaker-modeler-create-task';
  const nodeId = 'processmaker-modeler-create-task';

  const component = {
    extends: Task,
    watch: {
      'node.definition.name'(name) {
        switch (name) {
          default:
            this.$delete(this.markers.topRight, 'vocabulary');
            this.$delete(this.markers.topRight, 'clock');
        }
      },
    },
    mounted() {
      this.$set(this.markers.topRight, 'vocabulary', userTask);
    },
  };

  const nodeType = {
    id: nodeId,
    component,
    bpmnType: 'bpmn:ScriptTask',
    control: true,
    category: 'Other',
    icon: require('@/assets/toolpanel/iliosTask.svg'),
    label: 'Criar Tarefa',
    rank: 50,
    definition(moddle) {
      return moddle.create('bpmn:ScriptTask', {
        name: 'Criar Tarefa',
        implementation,
        config: JSON.stringify({}),
        backId: null,
      });
    },
    diagram(moddle) {
      return moddle.create('bpmndi:BPMNShape', {
        bounds: moddle.create('dc:Bounds', {
          height: 76,
          width: 116,
        }),
      });
    },
    inspectorConfig: [
      {
        name: 'Send Tweet',
        items: [
          {
            component: 'FormText',
            config: {
              label: 'Send Tweet',
              fontSize: '2em',
            },
          },
          {
            component: 'FormInput',
            config: idConfigSettings,
          },
          {
            component: 'FormInput',
            config: {
              label: 'Name',
              helper: 'Name',
              name: 'name',
            },
          },
        ],
      },
    ],
    entryRules(sequenceFlow){
      let result = []
      let findError
      result.push(rules.oneEntryConector(sequenceFlow))
      findError = result.find(el => el.result === false)
      if (findError){
        return findError
      } else {
        return {result: true}
      }
    },
    exitRules(genericFlow){
      let result = []
      let findError
      result.push(rules.oneExitConector(genericFlow))
      result.push(rules.entryNotIsMultGateway(genericFlow))
      findError = result.find(el => el.result === false)
      if (findError){
        return findError
      } else {
        return {result: true}
      }
    },
  };

  registerNode(nodeType, definition => {
    if (definition.get('implementation') === implementation) {
      return nodeId;
    }
  });
});
